import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'p2p-plugin';

  constructor(
  ) {
  }

  ngOnInit(): void {
    console.log('app component oninit')
  }
}
